import Vue from 'vue'
import adjustmentTransformer from '@/transformers/catalog/warehouse/adjustment'

/**
 * @author jorge nuñez lópez <>
 *
 * Create a new adjustment input 
 * @param newAdjustment New adjustment input object
 * @return {object}
 */

export default (newAdjustment, warehouseId) => {
  const payload = adjustmentTransformer.sendInput(newAdjustment)
  return Vue.$http.post(`iwarehouse/movement/${warehouseId}/in-by-adjustment/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/newAdjustmentInput.js